import { Stack, Text } from "@fluentui/react";
import { BreakpointType } from "../Container/ContainerFluid";
import { useBreakpoint } from "../Container/ContainerStyles";
import { commonConfigurationListGroupContainerStyles, commonConfigurationListGroupInnerContainerStyles, commonConfigurationListGroupStyles, lgCommonConfigurationListGroupStyles, mdCommonConfigurationListGroupStyles, smCommonConfigurationListGroupStyles, xlCommonConfigurationListGroupStyles, xxlCommonConfigurationListGroupStyles } from "./Styles/CommonConfigurationStyles";

export interface ICommonConfigurationAppGroupProps {
    title: string;
}

const CommonConfigurationAppGroup: React.FC<ICommonConfigurationAppGroupProps> = (props) => {
    const isSM = useBreakpoint(BreakpointType.sm);
    const isMD = useBreakpoint(BreakpointType.md);
    const isLG = useBreakpoint(BreakpointType.lg);
    const isXL = useBreakpoint(BreakpointType.xl);
    const isXXL = useBreakpoint(BreakpointType.xxl);
    
    return (
        <Stack
            horizontal
            horizontalAlign="space-between"
            verticalAlign="center"
            verticalFill
            className={commonConfigurationListGroupContainerStyles}
        >
            <Stack
                horizontal
                horizontalAlign="space-between"
                verticalAlign="center"
                verticalFill
                className={commonConfigurationListGroupInnerContainerStyles}
            >
                <Stack>
                    <Text
                        className={
                            isSM ?
                                smCommonConfigurationListGroupStyles : 
                            isMD ? 
                                mdCommonConfigurationListGroupStyles :
                            isLG ?
                                lgCommonConfigurationListGroupStyles :
                            isXL ?
                                xlCommonConfigurationListGroupStyles :
                            isXXL ?
                                xxlCommonConfigurationListGroupStyles
                            :
                                commonConfigurationListGroupStyles
                        }
                    >
                        {props.title}
                    </Text>
                </Stack>
            </Stack>
        </Stack>
    )
}

export default CommonConfigurationAppGroup